import axios from "axios";
import axiosInstance from "../../../../Utils/axios";
import { paginationQueryParams } from "../../../../Utils/paginationParam";
let cancelToken;

const grnChargeStatusModURL = "api/v1/core-app/additional-charge-status";

//obtaining the paginated data
export const getGrnChargeStatus = ({ rowsPerPage, search, sortOrder, pageNo }) => {
  if (cancelToken) {
    cancelToken.cancel("Operation canceled due to new request.");
  }
  cancelToken = axios.CancelToken.source();

  return axiosInstance.get(
    `${grnChargeStatusModURL}/list?${paginationQueryParams(rowsPerPage, search, sortOrder, pageNo)}`,
    {
      cancelToken: cancelToken.token,
    }
  );
};

//obtaining all fiscal sessions
export const getAllGrnChargeStatus = () => axiosInstance.get(`${grnChargeStatusModURL}/list?ordering=-id`);

//obtaining the previous page data from paginated data
export const getPrevious = (previous) => axiosInstance.get(previous);

//obtaining the next page data from paginated data
export const getNext = (next) => axiosInstance.get(next);

//obtaining the particular page data from paginated data
export const getPageGrnChargeStatus = ({ number, rowsPerPage, search }) =>
  axiosInstance.get(
    `${grnChargeStatusModURL}/list?offset=${(number - 1) * rowsPerPage}&limit=${rowsPerPage}&ordering=-id`
  );

export const getGrnChargeStatusById = (id) => axiosInstance.get(`${grnChargeStatusModURL}/retrieve/${id}`);

//creating function
export const createGrnChargeStatus = (body) => axiosInstance.post(`${grnChargeStatusModURL}/create`, body);
//updating function
export const updateGrnChargeStatus = (id, body) => axiosInstance.patch(`${grnChargeStatusModURL}/update/${id}`, body);

//searching function
export const handleSearch = (rowsPerPage, search, sortOrder) =>
  axiosInstance.get(
    `${grnChargeStatusModURL}/list?offset=0&limit=${rowsPerPage}&ordering=${sortOrder}&search=${search}`
  );

// checking the redundant data
export const checkRedundantDataGrnChargeStatusName = (e, cancelToken) =>
  axiosInstance.get(`${grnChargeStatusModURL}/list?name=${e.target.value.trim()}`, {
    cancelToken: cancelToken.token,
  });
